/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCallDto
 */
export interface CreateCallDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCallDto
     */
    callDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCallDto
     */
    comment: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCallDto
     */
    userId: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCallDto
     */
    doNotDisturb: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCallDto
     */
    sessionId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCallDto
     */
    partnerId: number;
}

/**
 * Check if a given object implements the CreateCallDto interface.
 */
export function instanceOfCreateCallDto(value: object): value is CreateCallDto {
    if (!('callDate' in value) || value['callDate'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('doNotDisturb' in value) || value['doNotDisturb'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    return true;
}

export function CreateCallDtoFromJSON(json: any): CreateCallDto {
    return CreateCallDtoFromJSONTyped(json, false);
}

export function CreateCallDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallDto {
    if (json == null) {
        return json;
    }
    return {
        
        'callDate': json['call_date'],
        'comment': json['comment'],
        'userId': json['user_id'],
        'doNotDisturb': json['do_not_disturb'],
        'sessionId': json['session_id'] == null ? undefined : json['session_id'],
        'partnerId': json['partner_id'],
    };
}

export function CreateCallDtoToJSON(json: any): CreateCallDto {
    return CreateCallDtoToJSONTyped(json, false);
}

export function CreateCallDtoToJSONTyped(value?: CreateCallDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'call_date': value['callDate'],
        'comment': value['comment'],
        'user_id': value['userId'],
        'do_not_disturb': value['doNotDisturb'],
        'session_id': value['sessionId'],
        'partner_id': value['partnerId'],
    };
}

